// extracted by mini-css-extract-plugin
module.exports = {"IntroSection":"IntroSection_IntroSection__CV4tq","description":"IntroSection_description__3vJWy","downwards":"IntroSection_downwards__3V4Z6"};